// extracted by mini-css-extract-plugin
module.exports = {"header":"mainpage_header__RuUsI","main":"mainpage_main__26bQE","buttonWrap":"mainpage_buttonWrap__1-L2l"};